import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";
import { Coordenada } from "src/app/models/entities/coordenada";
import { CapaSegmentosDTO } from "src/app/models/dtos/capa-segmentos-dto";
import { Segmento } from "src/app/models/entities/segmento";
import {
  AbstractControl,
  Validators,
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
} from "@angular/forms";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { Estado } from "src/app/models/entities/estado";
import { CatalogoService } from "src/app/services/catalogo.service";
import { LevantamientoSeleccionadoDTO } from "src/app/models/dtos/levantamiento-seleccionado-dto";
import { MapUtils } from "src/app/shared/utils/map-utils";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { take, toArray, concatMap, map, tap, filter } from "rxjs/operators";
import { CapaService } from "src/app/services/capa.service";
import { SegmentoService } from "src/app/services/segmento.service";
import { LoaderService } from "src/app/services/loader.service";
import { AlertasService } from "src/app/services/alertas.service";
import { Capa } from "src/app/models/entities/capa";
import { GooglePolyline } from "src/app/models/google-polyline";
import { from, Observable } from "rxjs";
import { LevantamientoAvanceService } from "src/app/services/levantamiento-avance.service";
import { DateUtils } from "src/app/shared/utils/date-utils";
import { UsuarioSesionDTO } from "src/app/models/dtos/usuario-sesion-dto";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { AngularFireUploadTask } from "@angular/fire/storage";
import { ArchivoCoordenadaService } from "src/app/services/archivo-coordenada.service";
import { CargaArchivoDTO } from "src/app/models/dtos/carga-archivo-dto";
import { ArchivoCoordenada } from "src/app/models/entities/archivo-coordenada";
import { InfoWindow } from "@agm/core/services/google-maps-types";

@Component({
  selector: "carga-evidencia",
  templateUrl: "./carga-evidencia.component.html",
  styleUrls: ["./carga-evidencia.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CargaEvidenciaComponent implements OnInit {
  @Input("datosObra")
  public datosObra: LevantamientoSeleccionadoDTO;

  @ViewChild("modalCargaArchivos")
  public modalCargaArchivos: any;
  public refModalCargaArchivos: NgbModalRef;

  @ViewChild("modalConfirmacionCarga")
  public modalConfirmacionCarga: NgbModalRef;
  public refModalConfirmacionCarga: NgbModalRef;

  @ViewChild("modalResultadosCarga")
  public modalResultadosCarga: NgbModalRef;
  public refModalResultadosCarga: NgbModalRef;

  @ViewChild("modalGaleria")
  public modalGaleria: any;
  public refModalGaleria: NgbModalRef;

  public map: any;
  public filtroForm: FormGroup;
  public catEstados: Estado[];
  public catDireccionesAdjuntas: ElementoCatalogo[];
  public catTipoObra: ElementoCatalogo[];
  public catTipoLevantamiento: ElementoCatalogo[];
  public catCapas: ElementoCatalogo[];
  public catSubElementos: ElementoCatalogo[];
  public catColores: ElementoCatalogo[];
  public readonly CAPA_PROYECTO_PROCESO: string = "0";
  public readonly CAPA_PROYECTO_PLANEACION: string = "4";
  public readonly CAPA_META_ACTUAL: string = "1";
  public readonly CAPA_COMPLETADO: string = "2";
  public readonly CAPA_ESTRUCTURA: string = "5";
  public archivos: File[] = [];
  public contadorPolylines: number = 0;
  public readonly fechaActual: number = new Date().getTime();
  public arregloCoordenadasElemento: Array<Coordenada[]> = new Array<
    Coordenada[]
  >();
  public latitudCentral: number;
  public longitudCentral: number;
  public latitudInicial: number;
  public longitudInicial: number;
  public latitudFinal: number;
  public longitudFinal: number;
  public colorCapa: string = "";
  public componenteCargado: boolean = false;
  public fechasSegmentos: string[];
  public segmentosPorFecha: Segmento[];
  public usuarioEnSesion: UsuarioSesionDTO;

  public mostrarMensajeEvidenciaCargada: boolean = false;
  public iconoCoordenada: any = {
    url: "../../../../../assets/img/iconos/coordenada-disponible.png",
    scaledSize: {
      width: 4,
      height: 4,
    },
  };

  public iconoMultimedia: any = {
    url: "../../../../../assets/img/iconos/icono-multimedia.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };

  public iconoPuente: any = {
    url: "../../../../../assets/img/iconos/icono-puente.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };

  public archivosForm: FormGroup;
  public task: AngularFireUploadTask;
  public percentage: Observable<number>;
  public snapshot: Observable<any>;
  public segmentoSeleccionado: Segmento;
  public indiceCoordenadaSeleccionada: number;
  public archivosDTO: CargaArchivoDTO[];
  public respuestaArchivosCargados: ArchivoCoordenada[];
  public iniciarCargaArchivos: boolean = false;
  public archivosSeleccionados: ArchivoCoordenada[];
  public infoWindowActual: InfoWindow = null;
  public infoWindowAbierto = false;
  maxSizeExceeded: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private catalogoService: CatalogoService,
    private mapUtils: MapUtils,
    public dateUtils: DateUtils,
    private capaService: CapaService,
    private segmentoService: SegmentoService,
    private loaderService: LoaderService,
    private alertasService: AlertasService,
    private levantamientoAvanceService: LevantamientoAvanceService,
    private facadeSesionService: FacadeSesionService,
    private changeDetector: ChangeDetectorRef,
    private ngbModalService: NgbModal,
    private archivoCoordenadaService: ArchivoCoordenadaService
  ) {}

  async ngOnInit() {
    this.facadeSesionService.usuarioEnSesionService
      .obtenerUsuario()
      .subscribe(
        (usuarioSesionDTO: UsuarioSesionDTO) =>
          (this.usuarioEnSesion = usuarioSesionDTO)
      );
    await this.cargarCatalogos();
    this.inicializarForm();
    this.componenteCargado = true;
    this.changeDetector.detectChanges();
  }

  public inicializarForm() {
    this.filtroForm = this.formBuilder.group({
      keyCatCapa: new FormControl("-1", [Validators.required, this.validarId]),
      fechaSegmento: new FormControl("-1", [
        Validators.required,
        this.validaFecha,
      ]),
    });
    this.filtroForm
      .get("keyCatCapa")
      .valueChanges.pipe(
        tap(() => {
          this.filtroForm.get("fechaSegmento").setValue("-1");
          this.segmentosPorFecha = null;
          this.mapUtils.centrarArregloDePolylines(
            this.map,
            this.obtenerCoordenadasProyecto()
          );
        }),
        filter((keyCatCapa: string) => keyCatCapa !== "-1")
      )
      .subscribe((keyCatCapa: String) => {
        let capaSegmentos: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
          (capaSegmentos: CapaSegmentosDTO) =>
            capaSegmentos.capa.keyCatCapa === keyCatCapa
        );
        //Cuando se crea una capa pueden venir muchos segmentos con la misma fecha, solo se toma una fecha.
        this.fechasSegmentos = Array.from(
          new Set<number>(
            capaSegmentos.segmentos.map(
              (segmento: Segmento) => segmento.fechaCreacion
            )
          )
        ).map((fecha: number) => fecha.toString());
      });

    this.filtroForm
      .get("fechaSegmento")
      .valueChanges.pipe(
        tap(() => {}),
        filter((fechaSegmento: string) => fechaSegmento !== "-1")
      )
      .subscribe((fechaSegmento: string) => {
        let capaSegmentos: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
          (capaSegmentos: CapaSegmentosDTO) =>
            capaSegmentos.capa.keyCatCapa ===
            this.filtroForm.get("keyCatCapa").value
        );
        this.segmentosPorFecha = capaSegmentos.segmentos.filter(
          (segmento: Segmento) =>
            segmento.fechaCreacion === parseInt(fechaSegmento)
        );
        switch (this.filtroForm.get("keyCatCapa").value) {
          case "1":
            this.colorCapa = this.catColores.find(
              (c: ElementoCatalogo) => c.key === "1"
            ).nombre;
            break;
          case "2":
            this.colorCapa = this.catColores.find(
              (c: ElementoCatalogo) => c.key === "2"
            ).nombre;
            break;
          case "3":
            this.colorCapa = this.catColores.find(
              (c: ElementoCatalogo) => c.key === "3"
            ).nombre;
            break;
          case "5":
            this.colorCapa = this.catColores.find(
              (c: ElementoCatalogo) => c.key === "5"
            ).nombre;
            break;
        }
        this.agregarDistancia();
        this.mapUtils.centrarArregloDePolylines(
          this.map,
          this.obtenerCoordenadasSegmentoSeleccionado(parseInt(fechaSegmento))
        );
        this.changeDetector.detectChanges();
      });
  }

  public agregarDistancia() {
    let coordenadasProyecto: Coordenada[] = []; //Coordenadas capa completado
    let capaProyecto: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
      (capaSegmentos: CapaSegmentosDTO) =>
        capaSegmentos.capa.keyCatCapa === this.CAPA_PROYECTO_PROCESO ||
        capaSegmentos.capa.keyCatCapa === this.CAPA_PROYECTO_PLANEACION
    );

    capaProyecto.segmentos.forEach((segmento: Segmento) => {
      segmento.coordenadas.forEach((coordenada: Coordenada) => {
        coordenadasProyecto.push(coordenada);
      });
    });

    this.segmentosPorFecha.forEach((segmento: Segmento) => {
      segmento.coordenadas.forEach((coordenada: Coordenada) => {
        let coordenadaProyecto: Coordenada = coordenadasProyecto.find(
          (coordenadaProyecto: Coordenada) =>
            coordenadaProyecto.latitud === coordenada.latitud &&
            coordenadaProyecto.longitud === coordenada.longitud
        );
        coordenada.distancia = coordenadaProyecto.distancia;
      });
    });
  }

  public cambioZoom(valorZoom: any): void {}

  public abrirModalGaleria(archivosSeleccionados: ArchivoCoordenada[]) {
    this.archivosSeleccionados = archivosSeleccionados;
    this.refModalGaleria = this.ngbModalService.open(this.modalGaleria, {
      size: "lg",
      centered: true,
      windowClass: "modal-lev-web",
      backdrop: "static",
      keyboard: false,
    });
  }

  public obtenerKeyColorPorKeyCapa(keyCapa: string): string {
    if (keyCapa === "1") {
      return "1";
    }
    if (keyCapa === "2") {
      return "2";
    }
    if (keyCapa === "3") {
      return "3";
    }
    if (keyCapa === "5") {
      return "5";
    }
  }

  public async cargarCatalogos(): Promise<void> {
    this.catEstados = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1))
      .toPromise();
    this.catDireccionesAdjuntas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS)
      .pipe(take(1))
      .toPromise();
    this.catTipoObra = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1))
      .toPromise();
    this.catTipoLevantamiento = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_LEVANTAMIENTOS)
      .pipe(take(1))
      .toPromise();
    this.catSubElementos = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SUB_ELEMENTOS)
      .pipe(take(1))
      .toPromise();
    this.catColores = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES)
      .pipe(take(1))
      .toPromise();
    this.catCapas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CAPAS)
      .pipe(take(1))
      .toPromise();
  }

  public obtenerHexColorCapa(key: string): string {
    return this.catColores.find((c: ElementoCatalogo) => c.key === key).nombre;
  }

  private validarId(control: AbstractControl) {
    return control.value === "-1" ? { error: "El campo es requerido" } : null;
  }
  private validaFecha(control: AbstractControl) {
    return control.value === 0 ? { error: "El campo es requerido" } : null;
  }
  public mapReady(event: any): void {
    this.map = event;
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.obtenerCoordenadasProyecto()
    );
  }

  public obtenerCoordenadasProyecto(): GooglePolyline[] {
    let segmentos: Array<Coordenada[]> = new Array<Coordenada[]>();
    this.datosObra.capasSegmentos.forEach((capaSegmentos: CapaSegmentosDTO) => {
      capaSegmentos.segmentos.forEach((segmento: Segmento) => {
        segmentos.push(segmento.coordenadas);
      });
    });
    return segmentos.map((segmento: Coordenada[]) =>
      this.crearPolyline(segmento)
    );
  }

  public obtenerCoordenadasSegmentoSeleccionado(fechaSeleccionada: number) {
    let capaSegmentos: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
      (capaSegmentos: CapaSegmentosDTO) =>
        capaSegmentos.capa.keyCatCapa ===
        this.filtroForm.get("keyCatCapa").value
    );
    this.segmentosPorFecha = capaSegmentos.segmentos.filter(
      (segmento: Segmento) => segmento.fechaCreacion === fechaSeleccionada
    );
    return this.segmentosPorFecha
      .map((segmento: Segmento) => segmento.coordenadas)
      .map((segmento: Coordenada[]) => this.crearPolyline(segmento));
  }

  public crearPolyline(points: Coordenada[]): any {
    return {
      googlePolylinePoints: points.map((p) => ({
        lat: p.latitud,
        lng: p.longitud,
      })),
    };
  }

  public obtenerMensajeValidacion(controlName: string): string {
    let error = "";
    const control = this.filtroForm.get(controlName);
    if (
      (control.touched && control.errors != null) ||
      (control.touched && control.value === "-1")
    ) {
      error = "El campo es requerido";
    }
    return error;
  }

  public obtenerMensajeValidacionArchivo(controlName: string): string {
    let error = "";
    const control = this.archivosForm.get(controlName);
    if (
      (control.touched && control.errors != null) ||
      (control.touched && control.value === "-1")
    ) {
      error = "El campo es requerido";
    }
    return error;
  }

  public mouseOver(event: any, infoWindow: InfoWindow) {
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
    }
    this.infoWindowActual = infoWindow;
    infoWindow.open();
    this.infoWindowAbierto = true;
  }

  public crearArregloPolylines(coordenadasElemento: Array<Coordenada[]>): any {
    return coordenadasElemento.map((coordenadas: Coordenada[]) =>
      this.crearPolyline(coordenadas)
    );
  }

  public obtenerPolylinePointsVistaPrevia(geoJson: any): Array<Coordenada[]> {
    let arregloCoordenadasElemento: Array<Coordenada[]> = new Array<
      Coordenada[]
    >();
    let contadorPolylines: number = 0;
    geoJson.features.forEach((feature) => {
      if (feature.geometry.type === "LineString") {
        let coordenadas: Coordenada[] = [];
        feature.geometry.coordinates.forEach((coordinate) => {
          let coordenada: Coordenada = {
            longitud: coordinate[0],
            latitud: coordinate[1],
          };
          coordenadas.push(coordenada);
        });
        arregloCoordenadasElemento.push(coordenadas);
        contadorPolylines++;
      }
    });
    this.contadorPolylines = contadorPolylines;
    return arregloCoordenadasElemento;
  }

  public obtenerCoordenadaCentralPolyline(
    coordenadasElemento: Array<Coordenada[]>
  ): Coordenada {
    let posicionCentralPolylines: number = Math.floor(
      coordenadasElemento.length / 2
    );
    let posicionCentralPolyline: number = Math.floor(
      coordenadasElemento[posicionCentralPolylines].length / 2
    );
    return coordenadasElemento[posicionCentralPolylines][
      posicionCentralPolyline
    ];
  }

  public obtenerCoordenadaInicialPolyline(
    coordenadasElemento: Array<Coordenada[]>
  ): Coordenada {
    return coordenadasElemento[0][0];
  }

  public obtenerCoordenadaFinallPolyline(
    coordenadasElemento: Array<Coordenada[]>
  ): Coordenada {
    let ultimaPolyline: Coordenada[] =
      coordenadasElemento[coordenadasElemento.length - 1];
    let ultimaCoordenada: Coordenada =
      ultimaPolyline[ultimaPolyline.length - 1];
    return ultimaCoordenada;
  }

  public eliminarArchivoParaCargar(indice: number): void {
    this.archivos.splice(indice, 1);
    this.eliminarFormArchivo(indice);
  }

  public async abrirModalAdjuntarArchivo(
    segmentoSeleccionado: Segmento,
    indiceCoordenadaSeleccionada: number
  ): Promise<void> {
    this.segmentoSeleccionado = segmentoSeleccionado;
    this.segmentoSeleccionado.nombreCapa = this.datosObra.capasSegmentos.find(
      (cs: CapaSegmentosDTO) => cs.capa.key === segmentoSeleccionado.keyCapa
    ).nombreCapa;
    this.indiceCoordenadaSeleccionada = indiceCoordenadaSeleccionada;

    this.refModalCargaArchivos = this.ngbModalService.open(
      this.modalCargaArchivos,
      {
        size: "lg",
        centered: true,
        windowClass: "modal-lev-web",
        backdrop: "static",
        keyboard: false,
      }
    );
    this.inicializarFormCargaArchivos();
  }

  public inicializarFormCargaArchivos() {
    this.archivosForm = this.formBuilder.group({
      archivos: this.formBuilder.array([]),
    });
    this.archivos = [];
    this.archivosDTO = [];
    this.respuestaArchivosCargados = [];
    this.iniciarCargaArchivos = false;
    this.mostrarMensajeEvidenciaCargada = false;
  }
  public agregarFormArchivo(): void {
    (this.archivosForm.get("archivos") as FormArray).push(
      this.crearFormArchivo()
    );
  }
  public eliminarFormArchivo(indice: number): void {
    (<FormArray>this.archivosForm.controls.archivos).removeAt(indice);
  }

  public crearFormArchivo(): FormGroup {
    return this.formBuilder.group({
      descripcion: new FormControl("", [Validators.required]),
    });
  }

  public agregarArchivosParaCargar(archivos: FileList): void {
    this.maxSizeExceeded = false;
    let maxSize: number = 250;
    for (let index = 0; index < archivos.length; index++) {
      let sizeFile: number = archivos[index].size * 1e-6;
      if (sizeFile > maxSize) {
        // console.log("El límite máximo es de 250 MB.");
        this.maxSizeExceeded = true;
      } else {
        this.agregarFormArchivo();
        this.archivos.push(archivos[index]);
      }
    }
    console.log(archivos);
  }

  public confirmarCargaDeArchivos() {
    this.refModalConfirmacionCarga = this.ngbModalService.open(
      this.modalConfirmacionCarga,
      {
        size: "lg",
        centered: true,
        windowClass: "modal-lev-web",
        backdrop: "static",
        keyboard: false,
      }
    );
    this.archivosDTO = [];
    for (let indice = 0; indice < this.archivos.length; indice++) {
      let archivoDTO: CargaArchivoDTO = {
        archivo: this.archivos[indice],
        descripcion: this.archivosForm.value.archivos[indice].descripcion,
        keyCapa: this.segmentoSeleccionado.keyCapa,
        keyCatCapa: this.filtroForm.get("keyCatCapa").value,
        keyCoordenada: this.indiceCoordenadaSeleccionada.toString(),
        keyLevantamientoObra: this.datosObra.levObra.key,
        keySegmento: this.segmentoSeleccionado.key,
        peso: this.archivos[indice].size,
        tipo: this.obtenerTipoArchivo(this.archivos[indice]),
      };
      this.archivosDTO.push(archivoDTO);
    }
  }

  public iniciarCargaDeArchivos() {
    this.refModalCargaArchivos.close();
    this.refModalConfirmacionCarga.close();
    this.refModalResultadosCarga = this.ngbModalService.open(
      this.modalResultadosCarga,
      {
        size: "lg",
        centered: true,
        windowClass: "modal-lev-web",
        backdrop: "static",
        keyboard: false,
      }
    );
    this.iniciarCargaArchivos = true;
    this.loaderService.activarLoaderScreen();
  }

  public obtenerTamanio(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  public async guardarRespuestasArchivosCargados(
    respuestaArchivoCargado: ArchivoCoordenada
  ) {
    this.respuestaArchivosCargados.push(respuestaArchivoCargado);
    if (this.respuestaArchivosCargados.length === this.archivosDTO.length) {
      this.loaderService.desactivarLoaderScreen();
      this.mostrarMensajeEvidenciaCargada = true;
      await this.levantamientoAvanceService.actualizarObra(this.datosObra);
      this.segmentoSeleccionado.coordenadas[
        this.indiceCoordenadaSeleccionada
      ].archivos = this.respuestaArchivosCargados;
    }
  }

  public obtenerTipoArchivo(archivo: File): "imagen" | "video" {
    return archivo["type"].split("/")[0] === "image" ? "imagen" : "video";
  }
}
